import React, { ButtonHTMLAttributes, FC, useState } from 'react';

export interface ToggleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  checked?: boolean;
  onChange?: (checked: any) => void;
}

/**
 * @example
 * <div className="flex space-x-2">
 *   <span>Toggle</span>
 *   <Toggle onChange={(checked) => console.log(checked)} />
 * </div>
 */
export const Toggle: FC<ToggleProps> = ({
  className = '',
  checked,
  onChange,
  onClick,
  ...props
}) => {
  const [internalChecked, setInternalChecked] = useState(checked);

  return (
    <button
      type="button"
      className={`toggle ${
        checked ? 'bg-brand-1' : 'bg-gray-200'
      } ${className}`}
      onClick={(e) => {
        const newValue = !internalChecked;
        setInternalChecked(newValue);
        onChange?.(newValue);
        onClick?.(e);
      }}
      {...props}
    >
      <span
        className={`toggle-slider ${
          checked ? 'translate-x-5' : 'translate-x-0'
        }`}
      ></span>
    </button>
  );
};
